import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";

export const ProjectCreationLayout = () => {
    return (
        <div className="min-h-screen overflow-hidden selection:bg-primary selection:text-primary-foreground relative bg-background text-foreground flex font-geist">
            <Sidebar />
            <div id="main-wrapper" className="flex flex-1 pl-0 pt-16 md:pt-0 transition-all duration-300 h-screen w-full">
                <main className="flex-1 min-w-0 flex flex-col z-10 overflow-y-auto no-scrollbar bg-transparent h-full relative">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};